// extracted by mini-css-extract-plugin
module.exports = {"c1fjr2il":"c1fjr2il"};